var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"my-tag tr",style:({'color': _vm.fontColor, 'borderColor': _vm.borderColor, 'backgroundColor': _vm.bgColor})},[_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }